import { Plus } from 'lucide-react';
import type { CatalogPreset } from '../engine/chain';
import { categoryIcon, CATEGORY_VAR } from './icons';

interface Props {
  preset: CatalogPreset;
  selected?: boolean;
  /** Use this effect (replaces the current stack). */
  onSelect?: () => void;
  /** Add this effect on top of the current stack. Omit to hide the button. */
  onAdd?: () => void;
}

export function EffectCard({ preset, selected, onSelect, onAdd }: Props) {
  const Icon = categoryIcon(preset.category);
  return (
    <div className="effect-card-wrap" style={{ ['--cat' as string]: CATEGORY_VAR(preset.category) }}>
      <button
        type="button"
        className="effect-card"
        aria-pressed={selected ? 'true' : 'false'}
        onClick={onSelect}
        data-testid={`preset-${preset.id}`}
      >
        <span className="effect-card__icon"><Icon size={18} /></span>
        <span className="effect-card__name">{preset.name}</span>
        <span className="effect-card__desc">{preset.description}</span>
        {preset.changesDuration && <span className="badge badge--warning effect-card__tag" title="Changes video duration">Speed</span>}
      </button>
      {onAdd && (
        <button
          type="button"
          className="effect-card__add"
          onClick={onAdd}
          aria-label={`Also play ${preset.name} at the same time`}
          title="Play this voice at the same time as the current one"
          data-testid={`add-${preset.id}`}
        >
          <Plus size={14} />
        </button>
      )}
    </div>
  );
}
